// eslint-disable-next-line import/no-webpack-loader-syntax
import termsAndConditions from "raw-loader!../assets/documents/terms-and-conditions.html";

function TermsAndConditions() {
    return (
        <div style={ { padding: ".8rem", overflow: "auto", height: "100%" } } dangerouslySetInnerHTML={ { __html: termsAndConditions } } ></div>
    )
}

export default TermsAndConditions;